<template>
  <div>
    <h6 class="text-h6 zubie-font q-mt-lg">Account Logo</h6>
    <div class="text-body2 q-mb-md">You can upload a logo to appear on your Zubie Sense Event PDF reports.</div>

    <div>
      <ImagePicker
        class="full-width"
        :class="[{ 'has-image': Boolean(logoUrl) }]"
        :model-value="logoUrl"
        :revert="showUndo"
        :style="{ height: '56px' }"
        @clear="onChange(null)"
        @revert="
          onChange(account.logoUrl);
          showUndo = false;
        "
        @update:model-value="onChange($event)"
        @upload="$emit('upload')"
        @uploaded="$emit('uploaded')"
      >
        <template #upload-message>
          <div class="row items-center no-wrap text-no-wrap line-height-1">
            <q-icon name="cloud_upload" />
            <div class="q-ml-xs">Upload a {{ logoUrl ? 'New' : 'Custom' }} Logo</div>
          </div>
        </template>
      </ImagePicker>

      <div class="logo-help text-caption text-grey-7">Recommended logo size: 3:1 ratio, e.g. 750x250</div>

      <BannerInfo v-if="showUndo && !logoUrl" class="q-mt-xs"
        >The logo will be set to the default Zubie logo.</BannerInfo
      >

      <q-card v-if="logoUrl" class="preview q-mt-sm q-pa-none">
        <div class="preview-header absolute-top-left text-grey-8 zubie-font">Preview</div>
        <div class="q-pa-md">
          <div class="report-preview text-right bg-white">
            <div class="report-preview__text">Platform Technology by</div>
            <div class="row justify-end items-center no-wrap">
              <div>
                <img class="report-preview__logo" :src="logoUrl" />
              </div>
              <div><q-separator class="report-preview__separator" size="1.75px" vertical /></div>
              <div>
                <img
                  class="report-preview__bosch-logo"
                  src="https://res.cloudinary.com/zubie/image/upload/v1765404558/apps/web/bosch_logo.png"
                />
              </div>
            </div>
          </div>
        </div>
      </q-card>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import BannerInfo from 'components/BannerInfo.vue';
import ImagePicker from 'components/ImagePicker.vue';

const emit = defineEmits(['update:logo-use', 'update:model-value', 'upload', 'uploaded']);

const store = useStore();

const account = computed(() => store.state.session.account);

const logoUrl = ref<string | null>(account.value.logoUrl);
const showUndo = ref(false);

async function onChange(value: string | null) {
  logoUrl.value = value;
  showUndo.value = true;
  emit('update:model-value', value);
}
</script>

<style scoped lang="scss">
.logo-help {
  margin: 4px 0 0 12px;
}

.preview {
  margin-left: 12px;
}

.preview-header {
  margin: 4px 0 0 12px;
}

.report-preview__logo {
  height: 40px;
  width: 100%;
  display: block;
  object-fit: contain;
}

.report-preview__separator {
  height: 45px;
  margin-left: 12px;
  margin-right: 14px;
  background-color: #b9c0c5;
}

.report-preview__bosch-logo {
  height: 50px;
  width: auto;
  display: block;
  object-fit: contain;
}

.report-preview__text {
  margin-right: 10px;
  margin-bottom: 3px;
  font-family:
    Calibri,
    Carlito,
    'Segoe UI',
    Candara,
    'Trebuchet MS',
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Helvetica Neue',
    Arial,
    sans-serif;
  font-size: 13.5px;
}
</style>
